/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Claim_RewardInputs */

const en_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Rewards`)
};

const ar_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المطالبة بالمكافآت`)
};

const de_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belohnungen beantragen`)
};

const es_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar recompensas`)
};

const fr_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer les récompenses`)
};

const it_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta ricompense`)
};

const ja_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報酬を受け取る`)
};

const ko_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드 받기`)
};

const pt_br_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicar recompensas`)
};

const ru_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить награды`)
};

const th_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรางวัล`)
};

const tr_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödülleri Talep Et`)
};

const zh_cn_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领奖励`)
};

const zh_tw_btn_claim_reward = /** @type {(inputs: Btn_Claim_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取獎勵`)
};

/**
* | output |
* | --- |
* | "Claim Rewards" |
*
* @param {Btn_Claim_RewardInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_claim_reward = /** @type {((inputs?: Btn_Claim_RewardInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Claim_RewardInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_claim_reward(inputs)
	if (locale === "ar") return ar_btn_claim_reward(inputs)
	if (locale === "de") return de_btn_claim_reward(inputs)
	if (locale === "es") return es_btn_claim_reward(inputs)
	if (locale === "fr") return fr_btn_claim_reward(inputs)
	if (locale === "it") return it_btn_claim_reward(inputs)
	if (locale === "ja") return ja_btn_claim_reward(inputs)
	if (locale === "ko") return ko_btn_claim_reward(inputs)
	if (locale === "pt_br") return pt_br_btn_claim_reward(inputs)
	if (locale === "ru") return ru_btn_claim_reward(inputs)
	if (locale === "th") return th_btn_claim_reward(inputs)
	if (locale === "tr") return tr_btn_claim_reward(inputs)
	if (locale === "zh_cn") return zh_cn_btn_claim_reward(inputs)
	return zh_tw_btn_claim_reward(inputs)
});